import React from "react";

const NotFoundPage: React.FC = () => {
  return (
    <div className="flex h-full items-center justify-center bg-indigo-500/50">
      <h1>
        Not Found Page
      </h1>
    </div>
  );
};

export default NotFoundPage;